import React from "react";

const LockerRoomChanOutline = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="149.581"
      height="154.266"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 149.581 154.266"
      xmlSpace="preserve"
      className="clickable"
    >
      <g
        fill="rgba(0,0,0,0)"
        className='object-glow'
        stroke="#ff5c97"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(-1794.235 -1908.161)"
      >
        <path
          strokeWidth="4"
          d="M1941.46 2007.31c-2.27-18.95-22.16-27.38-26.87-33.32-4.67-5.94-1.84-12.78-1.84-12.78-10.93 4.1-12.35-11.4-12.35-11.4-.47-5.05 6.84-5.47 9.15-8.67 1.74-2.46 3.01-8.3 3.86-11.18.24-.84 2.08-.7 2.08-.7-24.14-37.9-56.61-8.39-60.43-4.39-25.26 26.87 11.31 56.52 11.31 56.52-27.52 7.11-41.14.75-44.16-4.1-20.36-32.62-25.83.37-25.83.37-2.73 65.76 33.79 74.43 33.79 74.43 44.26 16.87 79.66 3.34 85.36 1.13 20.27-7.87 28.14-27.67 25.93-45.91z"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M1934.01 1930.95c-4.1.71-11.31.71-11.31.71-7.21 0-9.24-5.37-9.24-5.37l1.49 2.4-1.84 1.77s-2.46 7.76-2.95 9.55c-.76 2.76-9.19 5.23-9.45 7.48-.46 4-.01 4.77-.01 4.77 7.21-1.04 15.02-1.13 22.66-3.49 7.63-2.4 15.41-15.08 15.41-15.08 3.82-5.14-4.76-2.74-4.76-2.74z"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M1938.49 1948.77c0-2.07-4.81-4.81-4.81-4.81-1.65-.91-1.83-1.29-1.83-1.29l-1.91 1.92-2.43 2.09s-2.82 1.82-5.14 2.36c-1.98.47-4.84 1.12-7.76 1.56-6.44.97-13.4 1.58-13.4 1.58s.28 5.13 3.1 7.51c1.09.92 2.66 1.77 4.06 2.05 2.2.43 4.1-.05 4.1-.05 1.7-3.77 11.64-7.45 11.64-7.45 2.74-1.37 8.91-1.04 8.91-1.04 6.83-.66 5.47-4.43 5.47-4.43z"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default LockerRoomChanOutline;